export default __webpack_public_path__ + "static/media/line-item-green-icon.dbfcd373.svg";